<nz-modal
  (nzOnCancel)='onHide()'
  (nzOnOk)='update()'
  [nzClosable]='true'
  [nzOkDisabled]='form.invalid'
  [nzVisible]='show'
  nzOkText='Save Changes'
>
  <div *nzModalTitle><span class='fe fe-edit'></span> Update Company Information</div>
  <div *nzModalContent>
    <fe-form-message></fe-form-message>
    <form [formGroup]='form' class='grid grid-cols-1 gap-4' nz-form nzLayout='vertical'>
      <nz-form-item>
        <nz-form-label nzRequired>Phone Number</nz-form-label>
        <nz-form-control>
          <input formControlName="phoneNumber" nz-input type="tel" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Email Address</nz-form-label>
        <nz-form-control>
          <input formControlName="email" nz-input type="email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Website URL</nz-form-label>
        <nz-form-control>
          <input formControlName="websiteUrl" nz-input type="url" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Company Motto/Tagline</nz-form-label>
        <nz-form-control>
          <input formControlName="motto" nz-input type="text" />
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</nz-modal>